import * as BannerAds from '../services/api/requests/BannerAds'

export const doGetAllAds = async ({ setBannerAds, onEmpty, onError }) => {
  BannerAds.getAllBannerCards()
    .then(response => {
      if (response.data.length === 0) onEmpty()
      else setBannerAds(response.data)
    })
    .catch(() => {
      onError && onError()
    })
}
